/**
 * Volný zápis času -> kanonické "HH:mm".
 *
 * Při vyplňování záznamu nikdo nechce mačkat dvojtečku, takže bereme i holé
 * číslice a doplníme ji sami:
 *
 *   "850"  -> "08:50"     "8"     -> "08:00"
 *   "0850" -> "08:50"     "1830"  -> "18:30"
 *   "8:5"  -> "08:05"     "8.30"  -> "08:30"     "8 30" -> "08:30"
 *
 * Vrací null, když z toho platný čas nevyleze ("2570", "abc") — volající pak
 * nechá vstup tak, jak ho uživatel napsal, a označí ho jako chybný.
 */
export function parseTimeInput(raw: string): string | null {
  // Oddělovač je cokoli, co člověku přijde pod ruku místo dvojtečky.
  const s = raw.trim().replace(/[.,;\s]+/g, ':')
  if (!s) return null

  let hours: number
  let minutes: number

  const sep = s.indexOf(':')
  if (sep >= 0) {
    const h = s.slice(0, sep)
    const m = s.slice(sep + 1)
    if (!/^\d{1,2}$/.test(h)) return null
    if (m !== '' && !/^\d{1,2}$/.test(m)) return null
    hours = Number(h)
    minutes = m === '' ? 0 : Number(m) // "8:" == 8:00, "8:5" == 8:05
  } else {
    if (!/^\d+$/.test(s)) return null
    switch (s.length) {
      case 1: // "8"
      case 2: // "18"
        hours = Number(s)
        minutes = 0
        break
      case 3: // "850"
        hours = Number(s.slice(0, 1))
        minutes = Number(s.slice(1))
        break
      case 4: // "1830"
        hours = Number(s.slice(0, 2))
        minutes = Number(s.slice(2))
        break
      default:
        return null
    }
  }

  if (hours > 23 || minutes > 59) return null
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
}
